import * as React from 'react';
import { DropDownRowViewImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownrowview';
import { DropDownRowComponentProps, DropDownRowComponentState } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownrowcomponent';
import { DropDownRowCSSStyle } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownrowcss';
import './toneoption-style.css';


export class ToneOptionDropDownRowViewImpl extends DropDownRowViewImpl
{
     draw(props: DropDownRowComponentProps, state: DropDownRowComponentState, cssStyle: DropDownRowCSSStyle): JSX.Element | boolean
     {
         return(
            <>
            <div id="dropdown-web">
                {
                    this.getWebDropDown(props, state, cssStyle)
                }
            </div>
            <div id="dropdown-mobile">
                {
                    this.getMobileDropDown(props, state, cssStyle)
                }
            </div>


            </>
         );
     }

     getWebDropDown(props: DropDownRowComponentProps, state: DropDownRowComponentState, cssStyle: DropDownRowCSSStyle):JSX.Element
     {
         return(
             <>
            <tr onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseExit} style={props.cssStyle.getInnerWrapperCSSStyle(state.isEnabled, props.isLastIndex)} onClick={this.onRowSelect}>

                <td style={props.cssStyle.getIconDivCSSStyle()}>   
                    <img width='20px' height='20px' src={state.isEnabled ? this.getContext().getResources().getImage(props.dropDownDto.getIconName() + "_blue.svg") : this.getContext().getResources().getImage(props.dropDownDto.getIconName() + "_gray.svg")}/>
                </td>
                <td style={props.cssStyle.getIconNameLabelCSSStyle(state.isEnabled)}>
                    <label style={{ cursor:'pointer', margin:'0px 7px 0px 0px'}}>
                        {props.dropDownDto.getTitle()}
                    </label>
                </td>

            </tr>
             </>
         );
     }

     getMobileDropDown(props: DropDownRowComponentProps, state: DropDownRowComponentState, cssStyle: DropDownRowCSSStyle):JSX.Element
     {
         return(
            <>
                <tr onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseExit} style={props.cssStyle.getInnerWrapperCSSStyle(state.isEnabled, props.isLastIndex)} onClick={this.onRowSelect}>

                    <td style={props.cssStyle.getMobileIconDivCSSStyle()}>   
                        <img width='14px' height='14px' src={state.isEnabled ? this.getContext().getResources().getImage(props.dropDownDto.getIconName() + "_blue.svg") : this.getContext().getResources().getImage(props.dropDownDto.getIconName() + "_gray.svg")}/>
                    </td>
                    <td style={props.cssStyle.getMobileIconNameLabelCSSStyle(state.isEnabled)}>
                        <label style={{ cursor:'pointer', margin:'0px 7px 0px 0px'}}>
                            {props.dropDownDto.getTitle()}
                 
                        </label>
                    </td>

                </tr>
            </>
         );
     }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/toneoptions/toneoptiondropdownrowview.tsx